import Annotation from '@/components/Annotation';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { getLocalTimeStage } from '@/constants/delta-pro-ultra';
import { redirectTo404 } from '@/utils';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import getHostApi from '@/utils/singUtil/getHostApi';
import { useGlobal } from '@/utils/useGlobal';
import DeltaProUltraLaunch from '@elem/compPage/DeltaProUltra/Launch';
import DeltaProUltraPreLaunch from '@elem/compPage/DeltaProUltra/PreLaunch';
import DeltaProUltraTeaser from '@elem/compPage/DeltaProUltra/Teaser';
import DPUHomeSolution from '@elem/compPage/DPUHomeSolution';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { getCountryRegion } from '@/utils/countryRegion';
import request from '@/utils/request';
import { Spin } from 'antd-v5';
import { LoadingOutlined } from '@ant-design/icons';

const readyLangsFullSite = JSON.parse(process.env.NEXT_PUBLIC_READY_LANG_FULL_SITE || '[]');

const generalKey = 'product_home_yj751';
const whiteList = ['us', 'ca', 'jp', 'br', 'mx', 'eu', 'uk', 'de', 'it', 'es', 'fr', 'au', 'en', 'nl']; // 需要加入二维码qr, /delta-pro-ultra， next会自动加入en, 处理en时候的locale做重定向
export default function Page({ SEO }: any) {
    const { useLang, useEffect, useRouter, useState, useRef, getSystemTime, isMobile, gloproductlist } = useGlobal();
    const theme = 'black';
    const { t } = useLang('delta_pro_ultra');
    const router = useRouter();
    const { locale, query } = router;
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 切换时间：
    const teaserTimeStamp = new Date(getLocalTimeStage(locale, 'teaser')).getTime();
    const prelaunchTimeStamp = new Date(getLocalTimeStage(locale, 'prelaunch')).getTime();
    const launchTimeStamp = new Date(getLocalTimeStage(locale, 'launch')).getTime();
    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    // 计时器
    const timer: any = useRef(null);
    // 0: 未到 1: 预热teaser 2: pre-launch 预启页 3: launch 正式页(详情 + bundle早鸟众筹 + ...)
    const [stage, setStage] = useState(
        serverTimeStamp?.current >= launchTimeStamp && launchTimeStamp !== 0
            ? 3
            : serverTimeStamp?.current >= prelaunchTimeStamp && prelaunchTimeStamp !== 0
            ? 2
            : serverTimeStamp?.current >= teaserTimeStamp && teaserTimeStamp !== 0
            ? 1
            : 0,
    );

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTimeStamp.current = getSystemTime();
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }
        }
    };

    const handleRedirect = () => {
        const windowPath = window.location.pathname;

        if (locale !== 'en') {
            return;
        }
        const apiUrl = getCountryRegion(locale) === 'eu' ? process.env.NEXT_PUBLIC_LOGIN_HOST_EU : process.env.NEXT_PUBLIC_LOGIN_HOST;
        request
            .get(`${apiUrl}/website/address/finGeoByIp`)
            .then(async (res) => {
                if (res?.code !== '0') {
                    window.location.href = `/us${windowPath}`;
                    return;
                }
                const mapCustomCountryDataCenter: Record<string, string> = {
                    ie: 'eu',
                    ch: 'eu',
                    se: 'eu',
                    nl: 'eu',
                    in: 'us',
                    id: 'us',
                    is: 'us',
                };
                const macIp = res.data || { countryCode: 'US' };
                // TODO: 特殊站点做如下处理，例如：United Kingdom的CountryCode为GB, 需要处理为uk
                const COUNTRY_CODE_MAP = {
                    ...readyLangsFullSite.reduce((acc, current) => ({ ...acc, [current]: current }), {}),
                    gb: 'uk',
                    ru: 'cis',
                    sa: 'sa',
                };
                let countryCode = macIp?.countryCode?.toLowerCase();
                const countryRecord = countryCode;
                if (COUNTRY_CODE_MAP[countryCode]) {
                    countryCode = COUNTRY_CODE_MAP[countryCode];
                } else {
                    // 获取国家列表及匹配对应CountryCode的数据中心地址(eu/us)
                    let countryListData = [];
                    try {
                        const { data = [] } = await request.get(`${apiUrl}/general/location-api/countriesGroupByKey`);

                        // console.log(JSON.stringify(data));
                        countryListData = data;
                    } catch (err) {}
                    countryListData = countryListData.reduce((acc, current) => [...acc, ...current.countryResponses], []);
                    const { dataCenterCode = 'us', countryCode: countryCodeF } = countryListData.find((v) => v.countryCode === countryCode.toUpperCase());

                    if (whiteList.includes(countryCodeF?.toLowerCase())) {
                        window.location.href = `/${countryCodeF}${windowPath}`;
                        return;
                    }
                    // TODO: 后端预留其余多站点，但现版本仅考虑us和eu

                    countryCode = dataCenterCode === 'eu' ? 'eu' : 'us';
                }
                const ipLocale = typeof countryCode === 'string' ? countryCode : 'us';
                window.location.href = mapCustomCountryDataCenter[countryRecord]
                    ? `/${mapCustomCountryDataCenter[countryRecord]}${windowPath}`
                    : `/${ipLocale}${windowPath}`;
            })
            .catch(() => {
                window.location.href = `/us${windowPath}`;
            });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }

            // 支持localstorage设置时间以便测试
            let testTimeStamp = 0;
            const localeStorageTime = localStorage.getItem(`timer_deltaproultra_${locale}`);
            if (localeStorageTime) {
                testTimeStamp = new Date(localeStorageTime).getTime();
            }

            // 支持url路由参数设置时间以便测试（手机不方便设置localstorage的情况)
            const paramTime = query.timer;
            if (paramTime) {
                testTimeStamp = new Date(paramTime).getTime();
            }

            // 倒计时结束完成之前一直执行定时器任务
            const ALLOW_TIME = launchTimeStamp || prelaunchTimeStamp || teaserTimeStamp;
            if (serverTimeStamp.current < (testTimeStamp ? testTimeStamp : ALLOW_TIME)) {
                timer.current = setInterval(() => {
                    serverTimeStamp.current += 1000;
                    if (serverTimeStamp.current >= (testTimeStamp ? testTimeStamp : launchTimeStamp) && launchTimeStamp !== 0) {
                        clearInterval(timer.current);
                        return setStage(3);
                    } else if (serverTimeStamp.current >= (testTimeStamp ? testTimeStamp : prelaunchTimeStamp) && prelaunchTimeStamp !== 0) {
                        clearInterval(timer.current);
                        return setStage(2);
                    } else if (serverTimeStamp.current >= (testTimeStamp ? testTimeStamp : teaserTimeStamp) && teaserTimeStamp !== 0) {
                        clearInterval(timer.current);
                        return setStage(1);
                    } else {
                        setStage(0);
                        router.push('/404');
                        return;
                    }
                }, 1000);
            } else {
                setStage(launchTimeStamp ? 3 : prelaunchTimeStamp ? 2 : teaserTimeStamp ? 1 : 0);
                clearInterval(timer.current);
            }
            if (typeof window !== 'undefined') {
                window.document.addEventListener('visibilitychange', onVisibleChange);
            }
            handleRedirect();
            return () => {
                clearInterval(timer.current);
            };
        }
    }, []);

    if (locale === 'en') {
        return (
            <Spin
                style={{ height: '100vh', width: '100%', textAlign: 'center', lineHeight: '100vh' }}
                size="large"
                indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
            />
        );
    }

    return (
        <>
            <SEO title={productMsg?.title || t('launch.seo_title')} description={productMsg?.description || t('launch.seo_desc')} />
            <SEOlinksA list={whiteList} locale={locale} pathname={'delta-pro-ultra'} />
            <GtmPageLoad />
            <PageLayout hideToTop className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                {['us', 'ca', 'eu', 'uk', 'de', 'it', 'es', 'fr', 'au', 'nl'].includes(locale) ? (
                    <DPUHomeSolution theme={theme} productMsg={productMsg} />
                ) : (
                    <>
                        {stage === 1 && <DeltaProUltraTeaser />}
                        {stage === 2 && <DeltaProUltraPreLaunch />}
                        {stage === 3 && <DeltaProUltraLaunch theme={theme} productMsg={productMsg} />}
                    </>
                )}
                <Annotation borderTopColor="transparent" bgColor="transparent" boxStyle={isMobile ? {} : { width: '1120px' }} />
            </PageLayout>
            <style global jsx>
                {`
                    .ef-top-offers {
                        display: none;
                    }
                `}
            </style>
        </>
    );
}

export async function getServerSideProps({ locale = 'us' }: GetServerSidePropsContext) {
    if (!whiteList.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
